import { render } from "./FormPreviewModal.vue?vue&type=template&id=1247013d&scoped=true"
import script from "./FormPreviewModal.vue?vue&type=script&lang=js"
export * from "./FormPreviewModal.vue?vue&type=script&lang=js"

import "./FormPreviewModal.vue?vue&type=style&index=0&id=1247013d&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1247013d"]])

export default __exports__